var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.modal.dismiss()
            },
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "modal-title",
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [
          _c("span", [
            _vm._v(
              "Confirmation de paiement " + _vm._s(_vm.remainingTime) + " "
            ),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading_payment,
                  expression: "loading_payment",
                },
              ],
              staticClass: "loading",
            }),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-body" }, [
      _vm.delayed
        ? _c(
            "a",
            {
              staticClass: "text-center",
              attrs: { target: "_blank", href: _vm.paymentUrl },
              on: {
                click: function ($event) {
                  return _vm.newtabDsp()
                },
              },
            },
            [_vm._v("Pas de contenu ? Cliquer ici pour l'ouvrir")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          staticClass: "text-center",
        },
        [
          _vm._v(
            "\n\t\t\tEtat du paiement: " +
              _vm._s(_vm.payment_state) +
              "\n\t\t\t"
          ),
          _vm.loading_payment
            ? _c("span", [
                _vm._v("(mise à jour ... "),
                _c("i", { staticClass: "loading" }),
                _vm._v(")"),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("iframe", {
        staticClass: "w-100",
        staticStyle: { border: "none", "min-height": "610px" },
        attrs: {
          src: _vm.paymentUrl,
          onLoad: "$(document).trigger('page-load')",
          sandbox:
            "allow-same-origin allow-forms allow-modals allow-popups allow-scripts",
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c("div", { staticClass: "flex-center-center" }, [
        _vm.payment_state != _vm.CartService.PAYMENT_STATES.PAYMENT_CAPTURED &&
        (!_vm.payment.pay_for ||
          !_vm.CheckoutService.isOrderConfirmed(_vm.payment.pay_for))
          ? _c(
              "button",
              {
                staticClass: "eatbtn eatbtn-default",
                attrs: {
                  disabled:
                    _vm.payment_state ==
                    _vm.CartService.PAYMENT_STATES.PAYMENT_PENDING,
                },
                on: {
                  click: function ($event) {
                    return _vm.back()
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "icone icone-arrow-left4",
                  staticStyle: { "vertical-align": "middle" },
                }),
                _vm._v(" Abandonner\n\t\t\t"),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        [
          _vm.CartService.PAYMENT_STATES.PAYMENT_CAPTURED,
          _vm.CartService.PAYMENT_STATES.PAYMENT_AUTHORIZED,
        ].includes(_vm.payment_state)
          ? _c(
              "button",
              {
                staticClass: "eatbtn eatbtn-blue",
                on: {
                  click: function ($event) {
                    return _vm.$emit("go")
                  },
                },
              },
              [
                _vm._v("\n\t\t\t\tTerminé\n\t\t\t\t"),
                _c("i", {
                  staticClass: "icone icone-uniE669",
                  staticStyle: { "vertical-align": "middle" },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }